import classNames from 'classnames'

import csbGear from '@/assets/csbGear.svg'
import CardHover from '@/components/CardHover/CardHover'
import OutboundLink from '@/components/OutboundLink/OutboundLink'

import styles from './CSBEmbed.module.scss'

const nameToId = (name: string) =>
  name
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^a-z0-9-]/g, '')

type Props = {
  id: string
  url: string
}

const CSBEmbed = ({ id, url }: Props) => {
  const params = new URLSearchParams(url)
  const color = params.get('color')
  const extraRequirementCount = parseInt(params.get('extraRequirementCount') as string)
  const produces: string[] = JSON.parse(params.get('produces') as string)
  const requires: string[] = JSON.parse(params.get('requires') as string)
  const uses: string[] = JSON.parse(params.get('uses') as string)
  const parent = document.getElementById(id)

  parent!.querySelector('#csbLoad')?.remove()

  const extraRequirementString =
    extraRequirementCount === 1 ? '+1 other prerequisite' : `+${extraRequirementCount} other prerequisites`
  const href = `https://commanderspellbook.com/combo/${id}`

  return (
    <div className={classNames(styles.outer, 'shadow-sm')}>
      <OutboundLink url={href}>
        <div className={styles.idContainer}>
          {color
            ?.split('')
            .map((c, i) => <i className={`ms ms-${c.toLowerCase()} ms-cost ms-shadow`} key={`color-${i}`} />)}
        </div>
      </OutboundLink>

      <div className={styles.list}>
        {uses?.map((cardName) => (
          <div id={nameToId(cardName)} key={`uses-${nameToId(cardName)}`}>
            <CardHover name={cardName} />
          </div>
        ))}
        {requires?.map((cardName) => <div key={`requires-${cardName}`}>{cardName}</div>)}
        {extraRequirementCount > 0 && (
          <span>
            <OutboundLink className={styles.otherPrereq} url={href}>
              {extraRequirementString}
            </OutboundLink>
          </span>
        )}
      </div>

      {produces && (
        <div className={classNames(styles.list, styles.noBorder)}>
          {produces.map((feature) => (
            <span key={`produces-${feature}`}>
              <OutboundLink className={styles.produces} url={href}>
                {feature}
              </OutboundLink>
            </span>
          ))}
        </div>
      )}

      <OutboundLink url={href}>
        <div className={styles.logoContainer}>
          <img alt='' height='30' src={csbGear.src} />
          <span>Commander Spellbook</span>
        </div>
      </OutboundLink>
    </div>
  )
}

export default CSBEmbed
